// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"5b8434e4","99":"fbed81e6","120":"15a25345","182":"b6ef7d47","484":"3504d8f8","551":"6a0ef995","643":"e5cb6c90","838":"60487803","842":"17018118","940":"801349b6","961":"32729c7a","974":"4f44cd40"}[chunkId] + ".chunk.js";
};